import React, { FC } from 'react'
import { InlineMessageProps } from '../InlineMessage'
import { IModalAction } from './ModalAction'
import { ModalBase, MODAL_TYPES, ModalSize, TitleSize } from './ModalBase'

export interface IConfirmationModalProps {
  open?: boolean
  className?: string
  title?: string
  size?: ModalSize
  actions: IModalAction[]
  onClose: (action?: string) => any
  dataTest?: string
  error?: string
  children?: React.ReactNode
  closeOnBackdropClick?: boolean
  titleSize?: TitleSize
  titleClass?: string
  inlineMessageProps?: InlineMessageProps
}

export const ConfirmationModal: FC<IConfirmationModalProps> = ({
  actions,
  children,
  className,
  closeOnBackdropClick,
  dataTest,
  error,
  inlineMessageProps,
  onClose,
  open,
  size = 5,
  title,
  titleClass,
  titleSize,
}) => (
  <ModalBase
    open={open}
    title={title}
    titleSize={titleSize}
    titleClass={titleClass}
    className={className}
    actions={actions}
    onClose={onClose}
    dataTest={dataTest}
    error={error}
    inlineMessageProps={inlineMessageProps}
    modalType={MODAL_TYPES.confirmation}
    closeOnBackdropClick={closeOnBackdropClick}
    size={size}>
    {children && children}
  </ModalBase>
)
